<ng-container *ngIf="status === 401 || status === 403; else genericError">
  <dx-page-access-denied></dx-page-access-denied>
</ng-container>
<ng-template #genericError>
  <div class="row justify-content-center">
    <div class="col-auto">
      <fa-icon class="text-danger" [icon]="faExclamationTriangle" [fixedWidth]="true" size="6x"></fa-icon>
    </div>
  </div>
  <div class="row text-center pb-3">
    <div class="col">
      <h1 class="fw-black">Something went wrong</h1>
      <h5 class="text-secondary fw-normal">Don't worry, it's not you, it's us. We let our support team know of
        your issue.</h5>
      <h5 class="text-secondary fw-normal">Sorry for the inconvenience, feel free to try loading the page
        again.
      </h5>
    </div>
  </div>
  <div class="row justify-content-center pt-3">
    <div class="col-auto">
      <a class="btn btn-primary" [href]="reloadUrl">Reload Page</a>
    </div>
  </div>
</ng-template>
